export default __webpack_public_path__ + "static/media/RightArrowLogo.43a28570.svg";